import { theme } from '@global-engineering-shared/gweb-material-theme-next';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    paddingRight: theme.spacing(2),
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(1),
  },
}));

export default useStyles;
